window.Products.Clothing.UnisexPoloShirt = function() {}
window.Products.Clothing.UnisexPoloShirt.inherits(window.Products.Clothing.Shirt);